export const getMenu = () => {
  return {
    // 操作面板
    HomeView: {
      name: 'aside.homeMenu',
      ativePath: []
    },
    // 数据统计
    StatisticsView: {
      name: 'aside.statisticsMenu',
      ativePath: ['aside.statisticsMenu']
    },
    // 用户管理 - 用户列表
    EmployeeView: {
      name: 'aside.employeeListMenu',
      ativePath: ['aside.employeeMenu', 'aside.employeeListMenu']
    },
    // 用户管理 - 添加用户组
    AddDepartmentView: {
      name: 'aside.addDepartmentMenu',
      ativePath: ['aside.addDepartmentMenu']
    },
    // 用户管理 - 修改用户组
    UpdateDepartmentView: {
      name: 'aside.updateDepartmentMenu',
      ativePath: ['aside.updateDepartmentMenu']
    },
    // 用户管理 - 添加用户
    AddEmployeeView: {
      name: 'aside.addEmployeeMenu',
      ativePath: ['aside.addEmployeeMenu']
    },
    // 用户管理 - 修改用户
    UpdateEmployeeView: {
      name: 'aside.updateEmployeeMenu',
      ativePath: ['aside.updateEmployeeMenu']
    },
    // 用户管理 - 生成二维码
    GenerateCodeView: {
      name: 'aside.generateCodeMenu',
      ativePath: ['aside.employeeMenu', 'aside.generateCodeMenu']
    },
    // 用户管理 - 用户详情
    EmployeeDetailsView: {
      name: 'aside.employeeDetailsMenu',
      ativePath: ['aside.employeeDetailsMenu']
    },
    // 用户楼层权限
    EmployeeFloorView: {
      name: 'aside.employeeFloorMenu',
      ativePath: ['aside.employeeFloorMenu']
    },
    // 新增用户设备权限
    AddControllerPermissionView: {
      name: 'aside.addControllerPermissionMenu',
      ativePath: ['aside.employeeDetailsMenu', 'aside.addControllerPermissionMenu']
    },
    // 用户管理 - 导入用户
    ImportEmployeeView: {
      name: 'aside.importEmployeeMenu',
      ativePath: ['aside.employeeMenu', 'aside.importEmployeeMenu']
    },
    // 设备管理 - 设备列表
    ControllerView: {
      name: 'aside.controllerListMenu',
      ativePath: ['aside.controllerMenu', 'aside.controllerListMenu']
    },
    // 设备管理 - 常开常闭
    OpenCloseView: {
      name: 'aside.openCloseMenu',
      ativePath: ['aside.controllerMenu', 'aside.openCloseMenu']
    },
    // 通行管理 - 自动注册 - 通行权注册模板
    AutomaticView: {
      name: 'aside.accessTemplateMenu',
      ativePath: ['aside.accessMenu', 'aside.automaticRegisterMenu', 'aside.accessTemplateMenu']
    },
    // 通行管理 - 假期时间控制 - 假期控制模板
    WayleaveDateView: {
      name: 'aside.dateTemplateMenu',
      ativePath: ['aside.accessMenu', 'aside.dateTimeControlMenu', 'aside.dateTemplateMenu']
    },
    // 通行管理 - 假期时间控制 - 时间控制模板
    WayleaveTimeView: {
      name: 'aside.timeTemplateMenu',
      ativePath: ['aside.accessMenu', 'aside.dateTimeControlMenu', 'aside.timeTemplateMenu']
    },
    // 访客管理 - 访客记录
    VisitorRecordView: {
      name: 'aside.visitorRecordMenu',
      ativePath: ['aside.visitorMenu', 'aside.visitorRecordMenu']
    },
    // 访客管理 - 预约详情
    VisitorDetailsView: {
      name: 'aside.visitorDetailsMenu',
      ativePath: ['aside.visitorMenu', 'aside.visitorDetailsMenu']
    },
    // 访客管理 - 访客区域
    VisitorAreaView: {
      name: 'aside.visitorAreaMenu',
      ativePath: ['aside.visitorMenu', 'aside.visitorAreaMenu']
    },
    // 访客管理 - 申请配置
    VisitorConfigView: {
      name: 'aside.visitorApplyMenu',
      ativePath: ['aside.visitorMenu', 'aside.visitorApplyMenu']
    },
    // 通行记录
    CardRecordView: {
      name: 'aside.trafficRecordMenu',
      ativePath: ['aside.trafficRecordMenu']
    },
    // 实时记录
    RealTimeRecordView: {
      name: 'aside.realTimeRecordMenu',
      ativePath: ['aside.realTimeRecordMenu']
    },
    // 系统设置 - 登录用户
    UserView: {
      name: 'aside.loginUserMenu',
      ativePath: ['aside.systemMenu', 'aside.loginUserMenu']
    },
    // 操作记录
    LogRecordView: {
      name: 'aside.userOperationMenu',
      ativePath: ['aside.systemMenu', 'aside.userOperationMenu']
    },
    // 公司信息
    CompanyView: {
      name: 'aside.companyMenu',
      ativePath: ['aside.systemMenu', 'aside.companyMenu']
    },
    // 其他配置
    OtherSettingsView: {
      name: 'aside.otherMenu',
      ativePath: ['aside.systemMenu', 'aside.otherMenu']
    },
    // 添加设备
    AddControllerView: {
      name: 'aside.addControllerMenu',
      ativePath: ['aside.addControllerMenu']
    },
    // 添加区域
    AddAreaView: {
      name: 'aside.addAreaMenu',
      ativePath: ['aside.addAreaMenu']
    },
    // 添加区域
    UpdateAreaView: {
      name: 'aside.updateAreaMenu',
      ativePath: ['aside.updateAreaMenu']
    },
    // 修改设备
    UpdateControllerView: {
      name: 'aside.updateControllerMenu',
      ativePath: ['aside.updateControllerMenu']
    },
    // 设备详情
    ControllerDetailsView: {
      name: 'aside.controllerDetailsMenu',
      ativePath: ['aside.controllerDetailsMenu']
    },
    // 添加设备用户权限
    AddEmployeePermissionView: {
      name: 'aside.addEmployeePermissionMenu',
      ativePath: ['aside.addEmployeePermissionMenu']
    },
    // 设备用户权限
    ControllerEmployeeView: {
      name: 'aside.controllerEmployeeMenu',
      ativePath: ['aside.controllerEmployeeMenu']
    },
    // 通行权注册
    AddWayleaveView: {
      name: 'aside.addWayleaveMenu',
      ativePath: ['aside.addWayleaveMenu']
    },
    // 通行权
    WayleaveView: {
      name: 'aside.wayleaveMenu',
      ativePath: ['aside.wayleaveMenu']
    },
    // 操作日志详情
    LogRecordDetailsView: {
      name: 'aside.logRecordDetailsMenu',
      ativePath: ['aside.logRecordDetailsMenu']
    },
    // 新增模板
    AddTemplateView: {
      name: 'aside.addTemplateMenu',
      ativePath: ['aside.addTemplateMenu']
    },
    // 修改模板
    UpdateTemplateView: {
      name: 'aside.updateTemplateMenu',
      ativePath: ['aside.updateTemplateMenu']
    },
    // 新增常开常闭模板详情
    AddTemplateOpenCloseView: {
      name: 'aside.addTemplateOpenCloseMenu',
      ativePath: ['aside.addTemplateOpenCloseMenu']
    },
    // 修改常开常闭模板详情
    UpdateTemplateOpenCloseView: {
      name: 'aside.updateTemplateOpenCloseMenu',
      ativePath: ['aside.updateTemplateOpenCloseMenu']
    },
    // 新增假期详情
    AddWayleaveDateView: {
      name: 'aside.addWayleaveDateMenu',
      ativePath: ['aside.addWayleaveDateMenu']
    },
    // 修改假期详情
    UpdateWayleaveDateView: {
      name: 'aside.updateWayleaveDateMenu',
      ativePath: ['aside.updateWayleaveDateMenu']
    },
    // 修改假期详情
    UserDetailsView: {
      name: 'aside.userDetailsMenu',
      ativePath: ['aside.userDetailsMenu']
    },
    // 新增登录用户
    AddUserView: {
      name: 'aside.addUserMenu',
      ativePath: ['aside.addUserMenu']
    },
    // 修改登录用户
    UpdateUserView: {
      name: 'aside.updateUserMenu',
      ativePath: ['aside.updateUserMenu']
    },
    // 系统设置
    SystemSettingsView: {
      name: 'aside.systemSettingsMenu',
      ativePath: ['aside.systemMenu', 'aside.systemSettingsMenu']
    },
    // 个人信息
    PersonalView: {
      name: 'aside.personalMenu',
      ativePath: ['aside.systemMenu', 'aside.personalMenu']
    },
    // 添加访客区域
    AddVisitorAreaView: {
      name: 'aside.addVisitorAreaMenu',
      ativePath: ['aside.visitorMenu', 'aside.addVisitorAreaMenu']
    },
    // 修改访客区域
    UpdateVisitorAreaView: {
      name: 'aside.updateVisitorAreaMenu',
      ativePath: ['aside.visitorMenu', 'aside.updateVisitorAreaMenu']
    },
    // 修改访客区域
    AddVisitorAreaControllerView: {
      name: 'aside.addVisitorAreaControllerMenu',
      ativePath: ['aside.visitorMenu', 'aside.addVisitorAreaControllerMenu']
    },
    // 访客区域设备楼层
    VisitorAreaControllerFloorView: {
      name: 'aside.visitorAreaControllerFloorMenu',
      ativePath: ['aside.visitorMenu', 'aside.visitorAreaControllerFloorMenu']
    }
  }
}
